<template>
    <article class="my-4">

        <section class="form-row my-4">
            <label class="col-md-4 col-form-label">Source</label>
            <div class="col-md-6">
                <select name="data_source" class="form-control border border-dark" v-model="selectedSource">
                    <option v-for="(source, idx) in sources" :key="idx" :value="source">{{ idx }}</option>
                </select>
                <input type="hidden" name="formula_id" :value="selectedFormula.id" />
            </div>
        </section>

        <section class="form-row my-4">
            <label class="col-md-4 col-form-label">Formula</label>
            <div class="col-md-6">
                <select class="form-control border border-dark" v-model="selectedFormula">
                    <option v-for="formula of formulas" :value="formula">{{ formula.name }}</option>
                </select>
                <input type="hidden" name="formula_id" :value="selectedFormula.id" />
            </div>
        </section>

        <section class="alert alert-info text-center my-4">
            {{ selectedFormula.name + " | " + selectedFormula.formula + " | "+ selectedFormula.description }}
        </section>

        <section class="form-row my-4">
            <label class="col-md-4 col-form-label">Choose measurements:</label>
        </section>

        <div class="card-body m-5" v-if="loadingData"> <loading-spinner :loading="loadingData"></loading-spinner> </div>

        <div v-else>

            <div v-if="(availableMeasurements.length > 0)">

                <section class="form-row my-4" v-for="(item, index) of limitSelections">

                    <label class="col-md-4 col-form-label text-right">
                        <i v-if="index < selectedFormula.min_number_of_measurements " class="fas fa-asterisk fa-xs" style="color:red"></i>
                        {{index + 1}}:
                    </label>
                    <div class="col-md-6">
                        <html-v-select
                            name="measurement_ids[]"
                            label="extendedName"
                            item-value="id"
                            :selected="availableMeasurements.find(x => x.id == selectedMeasurements[index]) || null"
                            :options="availableMeasurements" >
                        </html-v-select>
                    </div>
                    
                </section>

            </div>

            <section class="alert alert-primary text-center my-4" v-else>Sorry. None of measurements of required type are available to select.</section>

        </div>
      
    </article>
</template>

<script>

import LoadingSpinner from '../common/LoadingSpinner';

export default{

    components: {
        "loading-spinner": LoadingSpinner,
    },

    props: {

        formulas: {
            type: Array,
            required: true,
        },

        defaultSelectedSource: {
            type: String,
            default: 'district',
        },

        sources: {
            type: Object,
            required: true,
        },

        defaultSelectedFormula: {
            type: Number,
            default: 1
        },

        defaultSelectedMeasurements: {
            type: Array,
            default: () => { return []; }
        },

        errors: {
            type: Object,
            default: () => { return {}; }
        },

        isSdg: {
            type: Boolean,
            default: false
        }

    },

    data() {
        return {
            selectedSource: this.defaultSelectedSource,
            selectedFormula: this.formulas.find((formula) => { return formula.id == this.defaultSelectedFormula; }),
            selectedMeasurements: [],
            availableMeasurements: [],
            url: "/admin/available-measurements/",
            loadingData: false,
        };
    },

    mounted() {

        this.isSdg ? this.url += 'sdg/' : this.url += 'kpi/';
        this.requestMeasurements();
    },

    computed: {

        // This needs to be present so we generate multiple measuremnent selects
        limitSelections() {
            let measureIdArray = [];

            for (let index = 1; index <= this.selectedFormula.max_number_of_measurements; index++) {
                measureIdArray.push(1);
            }

            return measureIdArray;
        }

    },

    watch: {

        selectedFormula() {
            this.requestMeasurements();
        },

        selectedSource() {
            this.requestMeasurements();
        }

    },

    methods: {

        addExtendedName()
        {
            this.availableMeasurements = this.availableMeasurements.map(x => {
                x.extendedName = x.name + " | type: " + x.type + " | code: " + x.code;
                return x;
            });
        },

        requestMeasurements() {

            this.loadingData = true;

            if (this.selectedFormula == null || this.selectedSource == null)
            {
                this.loadingData = true;
                return;
            }

            window.axios.get(window.APP_URL + this.url + this.selectedFormula.id + '/' + this.selectedSource)
                .then((response) => {

                    this.availableMeasurements = response.data;
                   
                    // To ensure limit of selectible measurements
                    if (this.defaultSelectedMeasurements.length <= this.selectedFormula.max_number_of_measurements) {
                        this.selectedMeasurements = this.defaultSelectedMeasurements;
                    } else {
                        this.selectedMeasurements = [];
                    }
                })
                .catch((error) => { window.console.error(error); })
                .then(() => {
                    this.addExtendedName();
                    this.loadingData = false; 
                });
        }
    },

};

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/formula/FormulaMeasurementsSelect.vue